"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateProfile = exports.reportError = exports.initSentry = void 0;

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _utils = require("./utils.js");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

var initialized = false;
/**
 * @param {*} sentrySettings {
 *    @param {*} dsn
 *    @param {*} releaseVersion
 *    @param {*} scope
 * }
 */

var initSentry = function initSentry(params) {
  var validParams = ['dsn', 'releaseVersion', 'scope'];
  var dsn = params.dsn,
      releaseVersion = params.releaseVersion,
      scope = params.scope;
  Object.keys(params).forEach(function (p) {
    if (!validParams.includes(p)) {
      console.error("Invalid param ".concat(p, " passed to SentryWrapper"));
    }
  });

  if (initialized) {
    console.warn('Sentry already initialized.');
    return;
  }

  initialized = true;

  if ((0, _utils.isLocalhost)()) {
    return;
  }

  Sentry.init({
    dsn: dsn,
    release: releaseVersion,
    attachStacktrace: true,
    debug: true
  });
  Sentry.configureScope(function (s) {
    s.setLevel(scope || 'warning');
  });
};
/**
   * @param {Object} profile {
   *    @property {string} user_id
   *    @property {string} name
   *    @property {string} email
   * }
*/


exports.initSentry = initSentry;

var updateProfile = function updateProfile(profile) {
  var prof = profile || {};

  if (!initialized) {
    console.error('Sentry not initialized.');
    return;
  }

  if ((0, _utils.isLocalhost)()) {
    return;
  }

  Sentry.configureScope(function (scope) {
    scope.setUser({
      email: prof.email || prof.user_id
    });
  });
};

exports.updateProfile = updateProfile;

var reportError = function reportError(error, errorInfo) {
  if (!initialized) {
    console.error('Sentry is not initialized. Not reporting the error.');
    console.error(error, errorInfo);
    return;
  }

  if (!(0, _utils.isLocalhost)()) {
    Sentry.withScope(function (scope) {
      Object.keys(errorInfo || {}).forEach(function (key) {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  } else {
    console.error(error, errorInfo);
  }
};

exports.reportError = reportError;